module.exports = __webpack_public_path__ + "static/heidi4-39fc7586e64a8ff733efa35041b9ed48.jpg";